import React, { FunctionComponent } from 'react';
import { Grid } from '@material-ui/core';
import summaryStyles from './SummaryStyles';
import ExpandedSection from '../expandedSection/ExpandedSection';
import clsx from 'clsx';
import { IExteriorColour, IInteriorColour } from '../../../../../../../../common/model/IColours';
import SummaryTitle from '../summaryTitle/SummaryTitle';
import ICarConfigOption from '../../../../../../../../common/model/ICarConfigOption';
import SummaryPrimaryContent from './SummaryPrimaryContent';
import SectionStatesWrapper, {
  ISectionStatesProps,
} from '../../../../../../common/components/configuratorStates/SectionStatesWrapper';

export interface ISummaryProps extends ISectionStatesProps {
  setIsExpanded: (value: boolean) => void;
  isExpanded: boolean;
  imageUrl: string;
  currency: string;
  exteriorColour: IExteriorColour;
  interiorColour: IInteriorColour;
  servicePlan?: ICarConfigOption;
  accessories?: ICarConfigOption[];
  accessoryPacks?: ICarConfigOption[];
  removeAction: (category: string, optionId?: string) => void;
  govCharges: number;
  isSecondaryCurrencyDisplay: boolean;
  isComplexModel?: boolean;
}

const Summary: FunctionComponent<ISummaryProps> = ({
  setIsExpanded,
  isExpanded,
  imageUrl,
  currency,
  exteriorColour,
  interiorColour,
  servicePlan,
  accessories,
  accessoryPacks,
  removeAction,
  govCharges,
  error,
  loading,
  isSecondaryCurrencyDisplay,
  isComplexModel,
}) => {
  const styles = summaryStyles();

  return (
    <>
      <Grid container={true} direction="column" wrap="nowrap" className={styles.root}>
        <Grid item={true}>
          <SummaryTitle setIsExpanded={setIsExpanded} isExpanded={isExpanded} />
        </Grid>
        <SectionStatesWrapper error={error} loading={loading}>
          <SummaryPrimaryContent imageUrl={imageUrl} isComplexModel={isComplexModel} />
        </SectionStatesWrapper>
      </Grid>
      {isExpanded && !loading && (
        <Grid
          container={true}
          direction="column"
          wrap="nowrap"
          className={clsx([styles.root, styles.expanded])}
          id="selections"
          data-test="container:summary:expanded_section"
        >
          <ExpandedSection
            exteriorColour={exteriorColour}
            interiorColour={interiorColour}
            govChargesPrice={govCharges}
            servicePlan={servicePlan}
            accessories={accessories}
            accessoryPacks={accessoryPacks}
            removeAction={removeAction}
            currency={currency}
            isSecondaryCurrencyDisplay={isSecondaryCurrencyDisplay}
          />
        </Grid>
      )}
    </>
  );
};

export default Summary;
